import { z } from 'zod';
/**
 * Ruxsat kalitlari — RBAC ning yagona manbai.
 *
 * Kodda hech qachon `user.role === 'admin'` yozilmaydi, faqat
 * `can(user, PERMISSIONS.ORDER_CONFIRM)`. Kalit amal nomi bilan ataladi,
 * rol nomi bilan emas — rollar o'zgaradi, amallar o'zgarmaydi.
 *
 * `packages/db/prisma/seed/rbac.ts` shu ro'yxatdan tip oladi: bu yerda
 * bo'lmagan kalit seed'da yozilsa, `tsc` yig'ilmaydi.
 */
export const PERMISSIONS = {
    // --- orders ---
    ORDER_VIEW_OWN: 'order.view_own',
    ORDER_VIEW_ALL: 'order.view_all',
    ORDER_CONFIRM: 'order.confirm',
    ORDER_HOLD: 'order.hold',
    ORDER_CANCEL: 'order.cancel',
    ORDER_CHANGE_STATUS: 'order.change_status',
    ORDER_CHANGE_STATUS_LOGISTICS: 'order.change_status_logistics',
    ORDER_RETURN: 'order.return',
    ORDER_ASSIGN_COURIER: 'order.assign_courier',
    ORDER_EDIT_NOTE: 'order.edit_note',
    // --- finance ---
    PAYMENT_RECORD: 'payment.record',
    PAYMENT_CONFIRM: 'payment.confirm',
    PAYMENT_REFUND: 'payment.refund',
    REPORT_VIEW: 'report.view',
    /// Tannarx va foyda — faqat Owner.
    REPORT_FINANCE: 'report.finance',
    // --- catalog ---
    CATALOG_VIEW: 'catalog.view',
    PRODUCT_CREATE: 'product.create',
    PRODUCT_EDIT: 'product.edit',
    PRODUCT_EDIT_PRICE: 'product.edit_price',
    PRODUCT_EDIT_MEDIA: 'product.edit_media',
    PRODUCT_EDIT_TAGS: 'product.edit_tags',
    PRODUCT_ARCHIVE: 'product.archive',
    STOCK_MANAGE: 'stock.manage',
    IMPORT_RUN: 'import.run',
    CONSIGNMENT_MANAGE: 'consignment.manage',
    REFERENCE_MANAGE: 'reference.manage',
    SEARCH_LOG_VIEW: 'search_log.view',
    // --- delivery ---
    DELIVERY_MY_SHIPMENTS: 'delivery.my_shipments',
    DELIVERY_MARK_DELIVERED: 'delivery.mark_delivered',
    // --- system ---
    GARAGE_MANAGE_CUSTOMER: 'garage.manage_customer',
    USER_MANAGE: 'user.manage',
    ROLE_MANAGE: 'role.manage',
    SETTING_MANAGE: 'setting.manage',
    AUDIT_VIEW: 'audit.view',
};
export const PERMISSION_CODES = Object.values(PERMISSIONS);
export const PermissionCodeSchema = z.enum(PERMISSION_CODES);
/** Tizim rollari. Yangi rol qo'shish mumkin, lekin bu beshtasi o'chirilmaydi. */
export const SYSTEM_ROLES = ['OWNER', 'ADMIN', 'OPERATOR', 'CONTENT', 'COURIER'];
export const SystemRoleCodeSchema = z.enum(SYSTEM_ROLES);
//# sourceMappingURL=permissions.js.map